var a = Object.defineProperty;
var p = (o, n, t) => n in o ? a(o, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : o[n] = t;
var e = (o, n, t) => p(o, typeof n != "symbol" ? n + "" : n, t);
import { HttpClient as r, httpClient as s } from "../../httpClient.js";
class d extends r {
  constructor() {
    super(...arguments);
    e(this, "baseEndpoint", "/video-calls");
  }
  async join(t) {
    return s.post(
      `${this.baseEndpoint}/${t}/join`,
      {}
    );
  }
  async confirm(t) {
    return s.post(`${this.baseEndpoint}/${t}/confirm`, {});
  }
  async end(t) {
    return s.post(`${this.baseEndpoint}/${t}/end`, {});
  }
  async takePhoto(t, i) {
    return s.post(`${this.baseEndpoint}/${t}/photo`, { dataUrl: i });
  }
}
const $ = new d();
export {
  $ as default
};
